import React from 'react';
import styles from '~/widgets/ActionTag/ActionTag.module.scss';
import { TagActionType } from '~/pages/CharacterSheet/types';

export interface ActionTagProps {
  text: string;
  actionType: TagActionType;
  value: number;
  canAfford: boolean;
  onClick: () => void;
  title: string;
}

export const ActionTag: React.FC<ActionTagProps> = ({
  text,
  actionType,
  canAfford,
  onClick,
  title,
}) => {
  const isPositive = actionType === 'GAIN_HEALTH';

  return (
    <button
      className={`${styles.actionTag} ${isPositive ? styles['actionTag--positive'] : styles['actionTag--negative']} ${!canAfford ? styles['actionTag--disabled'] : ''}`}
      disabled={!canAfford}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      onDoubleClick={(e) => e.stopPropagation()}
      title={title}
    >
      {text}
    </button>
  );
};
